import React from "react";
import { API_ENDPOINT } from "../constants";

function useLectureSearch() {
    const [search, setSearch] = React.useState("");
    const [filteredLectures, setFilteredLectures] = React.useState([]);

    React.useEffect(() => {
        fetch(`${API_ENDPOINT}/student/search?course_code=${"test"}&query=${search}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setFilteredLectures(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [search]);

    const clearSearch = () => {
        setSearch("");
        setFilteredLectures([]);
    };

    return { search, setSearch, filteredLectures, clearSearch };
}

export default useLectureSearch;